import { render, staticRenderFns } from "./BandwidthHog.vue?vue&type=template&id=bf9dfb56"
import script from "./BandwidthHog.vue?vue&type=script&lang=js"
export * from "./BandwidthHog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports